module.exports = __webpack_public_path__ + "static/media/1mg-lido-mall.d2fe4460.png";